<span>
  {{ (currentValueMs) ? (currentValueMs | date:'mm:ss') : (timerSec*1000 | date:'mm:ss') }}
</span>
